<div #container class="super-latex-container" [class.has-highlights]="highlight()">
  <div #linesWrapper class="latex-lines-wrapper" [style.padding]="padding()">
    @for (node of latexNodes(); track node.id ?? node.latex; let i = $index) {
      <div
        class="latex-line"
        [class]="node.custom_class ?? ''"
        [class.align-on-equals]="alignOnEquals()"
        [class.dimmed]="node.id && dimmedNodes().has(node.id)"
        [ngStyle]="lineStyles()[i]"
        [attr.data-node-key]="node.id ?? node.latex"
      >
        <markdown [data]="node.latex" katex [katexOptions]="katexOptions" />
      </div>
    }
  </div>
  @for (target of annotationTargets(); track target.annotation.id) {
    <dojo-annotation-engine [annotation]="target.annotation" [targetElement]="target.element" />
  }
</div>
